import { useSyncExternalStore } from 'react';

import { onlineManager } from '@tanstack/react-query';

/**
 * Le serveur est-il joignable en ce moment ? Miroir de lecture de
 * `connectivity.ts`, pour les rares affichages qui le disent a l'utilisateur
 * (la pastille « Hors ligne »). Les écrans de données, eux, n'ont pas a le
 * consulter : leurs requetes se mettent en pause toutes seules.
 */
// Références stables : recréées a chaque rendu, elles feraient se désabonner
// et se réabonner le composant a chaque passage.
const subscribe = (onStoreChange: () => void) => onlineManager.subscribe(onStoreChange);
const getSnapshot = () => onlineManager.isOnline();

export function useServerReachable(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
